export default __webpack_public_path__ + "static/media/necroticpustule.3bca3487.png";